type CreatePersonalCardArgs = {
  sourceCardId?: string;
  returnTo?: string;
};

function buildApiUrl(args: CreatePersonalCardArgs): string {
  const params = new URLSearchParams();
  if (args.sourceCardId) {
    params.set('sourceCardId', args.sourceCardId);
  }
  if (args.returnTo) {
    params.set('returnTo', args.returnTo);
  }
  const query = params.toString();
  return `/api/identity/create-personal-card${query ? `?${query}` : ''}`;
}

/**
 * Calls the create-personal-card API route and returns the destination URL.
 * The API evaluates the Unified Profile rollout flags server-side and returns
 * either the new identity editor URL (creating a draft identity) or the legacy
 * `/cards/personal/new` URL.
 *
 * Usage:
 * ```ts
 * const url = await createPersonalCard({ sourceCardId });
 * Router.push(url);
 * ```
 */
export async function createPersonalCard(args: CreatePersonalCardArgs = {}): Promise<string> {
  const response = await fetch(buildApiUrl(args));
  const data = await response.json();
  return data.url;
}
